<button class="rpc-notification-checkbox-btn" matRipple [matRippleCentered]="true"
    [title]="(checked ? 'NOTIFICATION_CHECKBOX.TITLES.MARK_AS_READ' : 'NOTIFICATION_CHECKBOX.TITLES.MARK_AS_UNREAD') | translate" type="button"
    [class.rpc-notification-checkbox-btn--checked]="checked" (click)="onClick($event)">

    <span class="rpc-notification-checkbox-btn-bg"></span>

    <span class="rpc-notification-checkbox-btn-text"></span>

</button>